import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { artifactStore, timStore, viewsStore } from "@/hooks";
import { PanelCard, Typography, TextButton } from "@/components/common";
import { ArtifactListDisplay } from "@/components/artifact/display";


/**
 * Displays parent and child artifacts in the selected trace matrix.
 */
const __default__ = {
  name: "TraceMatrixArtifacts",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const traceMatrix = computed(() => timStore.selectedTraceMatrix);

const sourceType = computed(() => traceMatrix.value?.sourceType || "");
const sourceArtifacts = computed(() =>
  artifactStore.getArtifactsByType(sourceType.value)
);
const sourceArtifactsLabel = computed(() =>
  sourceArtifacts.value.length === 1
    ? "1 Child Artifact"
    : `${sourceArtifacts.value.length} Child Artifacts`
);

const targetType = computed(() => traceMatrix.value?.targetType || "");
const targetArtifacts = computed(() =>
  artifactStore.getArtifactsByType(targetType.value)
);
const targetArtifactsLabel = computed(() =>
  targetArtifacts.value.length === 1
    ? "1 Parent Artifact"
    : `${targetArtifacts.value.length} Parent Artifacts`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(PanelCard), {
      title: targetArtifactsLabel.value,
      collapsable: "",
      borderless: ""
    }, {
      "title-actions": _withCtx(() => [
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "View Parents",
          icon: "view-tree",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).addDocumentOfTypes([targetType.value])))
        })
      ]),
      default: _withCtx(() => [
        (targetArtifacts.value.length > 0)
          ? (_openBlock(), _createBlock(_unref(ArtifactListDisplay), {
              key: 0,
              artifacts: targetArtifacts.value,
              "data-cy": "list-selected-parent-artifacts",
              "item-data-cy": "list-selected-parent-artifact-item",
              class: "bg-background rounded",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(viewsStore).addDocumentOfNeighborhood($event)))
            }, null, 8, ["artifacts"]))
          : (_openBlock(), _createBlock(_unref(Typography), {
              key: 1,
              l: "1",
              variant: "caption",
              value: "There are no parent artifacts."
            }))
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_unref(PanelCard), {
      title: sourceArtifactsLabel.value,
      collapsable: "",
      borderless: ""
    }, {
      "title-actions": _withCtx(() => [
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "View Children",
          icon: "view-tree",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(viewsStore).addDocumentOfTypes([sourceType.value])))
        })
      ]),
      default: _withCtx(() => [
        (sourceArtifacts.value.length > 0)
          ? (_openBlock(), _createBlock(_unref(ArtifactListDisplay), {
              key: 0,
              artifacts: sourceArtifacts.value,
              "data-cy": "list-selected-child-artifacts",
              "item-data-cy": "list-selected-child-artifact-item",
              class: "bg-background rounded",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(viewsStore).addDocumentOfNeighborhood($event)))
            }, null, 8, ["artifacts"]))
          : (_openBlock(), _createBlock(_unref(Typography), {
              key: 1,
              l: "1",
              variant: "caption",
              value: "There are no child artifacts."
            }))
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})